var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F15A22",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m7.2 7.2 9.6 9.6M16.8 7.2l-9.6 9.6"
  })));
};
export { SvgError as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoCiAgICBkPSJNMTIgMjRDMTguNjI3NCAyNCAyNCAxOC42Mjc0IDI0IDEyQzI0IDUuMzcyNTggMTguNjI3NCAwIDEyIDBDNS4zNzI1OCAwIDAgNS4zNzI1OCAwIDEyQzAgMTguNjI3NCA1LjM3MjU4IDI0IDEyIDI0WiIKICAgIGZpbGw9IiNGMTVBMjIiCiAgLz4KPHBhdGgKICAgIGQ9Ik03LjE5OTIyIDcuMTk5MjJMMTYuNzk5MiAxNi43OTkyIgogICAgc3Ryb2tlPSJ3aGl0ZSIKICAgIHN0cm9rZS13aWR0aD0iMiIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAvPgo8cGF0aAogICAgZD0iTTE2Ljc5OTIgNy4xOTkyMkw3LjE5OTIyIDE2Ljc5OTIiCiAgICBzdHJva2U9IndoaXRlIgogICAgc3Ryb2tlLXdpZHRoPSIyIgogICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIC8+Cjwvc3ZnPgo=";